import * as yup from "yup";

export const loginWithPasswordSchema = (t: (key: string) => string) => {
    return yup.object({
        userLogonId: yup.string().required(t('main.required.userLogonId')),
        userName: yup.string().when('userLogonId', {
            is: (val: string) => !val?.startsWith('TRA'),
            then: (schema) => schema.required(t('main.required.password')),
            otherwise: (schema) => schema.notRequired(),
        }),
    });
};